/** CountryField expects uppercase ISO codes; phone selectors use lowercase for flags. */
export function normalizeEmployeePhoneCountry<T>(employee: T): T {
  if (typeof FormData !== 'undefined' && employee instanceof FormData) {
    const country = employee.get('phone_country')
    if (typeof country !== 'string') return employee
    const normalized = country.trim().toUpperCase()
    if (country === normalized) return employee
    const payload = new FormData()
    employee.forEach((value, key) => payload.append(key, value))
    payload.set('phone_country', normalized)
    return payload as T
  }
  if (!employee || typeof employee !== 'object' || Array.isArray(employee)) return employee
  const country = (employee as Record<string, unknown>).phone_country
  if (typeof country !== 'string') return employee
  return { ...employee, phone_country: country.trim().toUpperCase() }
}
